import type { LucideIcon } from 'lucide-react';
import {
  CheckCircle2,
  ClipboardList,
  KeyRound,
  ListTodo,
  MessageCircle,
  Rocket,
  Settings,
  User,
  Users,
  Webhook,
} from 'lucide-react';
import { cn } from '../../lib/utils';

export const PROJECT_TABS: ReadonlyArray<{
  suffix: 'tasks' | 'completed' | 'settings';
  label: string;
  icon: LucideIcon;
}> = [
  { suffix: 'tasks', label: 'Tasks', icon: ListTodo },
  { suffix: 'completed', label: 'Completed', icon: CheckCircle2 },
  { suffix: 'settings', label: 'Settings', icon: Settings },
];

export const SETTINGS_LINKS: ReadonlyArray<{
  to: string;
  label: string;
  prefix: boolean;
  icon: LucideIcon;
  orgAdmin?: boolean;
  systemAdmin?: boolean;
}> = [
  { to: '/settings/profile', label: 'Profile', prefix: false, icon: User },
  { to: '/settings/members', label: 'Members', prefix: false, icon: Users },
  { to: '/settings/tokens', label: 'Tokens', prefix: false, icon: KeyRound },
  { to: '/settings/service-requests', label: 'Service Requests', prefix: false, icon: ClipboardList, orgAdmin: true },
  { to: '/settings/business-requirements', label: 'Business Requirements', prefix: false, icon: Rocket, systemAdmin: true },
  { to: '/settings/webhooks', label: 'Webhooks', prefix: true, icon: Webhook, orgAdmin: true },
  { to: '/settings/whatsapp', label: 'WhatsApp', prefix: false, icon: MessageCircle, orgAdmin: true },
  { to: '/admin/users', label: 'Users', prefix: true, icon: Users, systemAdmin: true },
];

export function visibleSettingsLinks(isOrgAdmin: boolean, isSystemAdmin = false) {
  return SETTINGS_LINKS.filter((link) => (!link.orgAdmin || isOrgAdmin) && (!link.systemAdmin || isSystemAdmin));
}

export function navItemClass(active: boolean): string {
  return cn(
    'rounded-md px-2.5 py-1 text-sm transition-colors',
    active
      ? 'bg-accent font-medium text-foreground'
      : 'text-muted-foreground hover:bg-accent/70 hover:text-foreground',
  );
}

/** Structural section label, kept quieter than the project name it sits beside. */
export const sidebarLabelClass =
  'px-2.5 pb-1 text-[11px] font-semibold text-muted-foreground/80';

export function sidebarItemClass(active: boolean): string {
  return cn(
    'relative isolate flex w-full items-center gap-2.5 rounded-full px-3 py-1.5 text-sm leading-5 transition-colors duration-150',
    active ? 'font-semibold text-white' : 'font-medium text-muted-foreground hover:bg-muted hover:text-foreground',
  );
}

export function sidebarIconClass(active: boolean): string {
  return cn('h-4 w-4 shrink-0 transition-colors duration-150', active ? 'text-brand-ice' : 'text-muted-foreground');
}
